import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import {
  Box,
  Button,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core';
import { stores } from 'mobx-store';
import { TeamDTO } from '../../DTO';
import TeamForm from './TeamForm'; // Make sure this path is correct

const TeamsScreen: React.FC = observer(() => {
  const { liveScoringStore } = stores;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState<TeamDTO | null>(null);

  useEffect(() => {
    liveScoringStore.getTournaments();
    liveScoringStore.getTeams();
  }, []);

  const handleOpenAdd = () => {
    setSelectedTeam(null);
    setIsModalOpen(true);
  };

  const handleOpenEdit = (team: TeamDTO) => {
    setSelectedTeam(team);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    liveScoringStore.getTeams(); // Refresh the list after close
  };

  return (
    <Container>
      <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="h4" gutterBottom>
          Teams Management
        </Typography>
        <Button variant="contained" color="primary" onClick={handleOpenAdd}>
          Add New Team
        </Button>
      </Box>
      <TableContainer component={Paper} style={{ marginTop: 20 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Short Name</TableCell>
              <TableCell>Logo</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {liveScoringStore.teams.map((team) => (
              <TableRow key={team.id}>
                <TableCell>{team.id}</TableCell>
                <TableCell>{team.name}</TableCell>
                <TableCell>{team.nameShort}</TableCell>
                <TableCell>
                  {team.logo ? <img src={team.logo} alt="Team Logo" style={{ height: 40 }} /> : 'N/A'}
                </TableCell>
                <TableCell align="right">
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => handleOpenEdit(team)}
                  >
                    Edit
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TeamForm
        open={isModalOpen}
        onClose={handleCloseModal}
        team={selectedTeam}
      />
    </Container>
  );
});

export default TeamsScreen;